// Textes fixes des pages (HTML) qui citent le nom des créatures : leur modèle est dans un attribut
// (`data-creature-text` pour le texte, `data-creature-label` pour aria-label), rempli d'après la configuration du jeu.
import { creatureText, setGameConfig, type GameConfig } from '../../shared/game-config.ts';

/** Charge la configuration du jeu (celle par défaut reste en place si le serveur ne répond pas). */
export async function loadGameConfig(url: string, init?: RequestInit): Promise<void> {
  try {
    const response = await fetch(url, init);
    if (response.ok) setGameConfig(await response.json() as GameConfig);
  } catch { /* hors ligne : nom par défaut */ }
}

export function applyCreatureTexts(root: ParentNode = document): void {
  for (const element of root.querySelectorAll<HTMLElement>('[data-creature-text]')) element.textContent = creatureText(element.dataset.creatureText ?? '');
  for (const element of root.querySelectorAll<HTMLElement>('[data-creature-label]')) element.setAttribute('aria-label', creatureText(element.dataset.creatureLabel ?? ''));
}
